import { render, staticRenderFns } from "./BusinessCloseDay.vue?vue&type=template&id=23c8cdc1&"
import script from "./BusinessCloseDay.vue?vue&type=script&lang=js&"
export * from "./BusinessCloseDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports